import { useStaticQuery, graphql } from "gatsby";

export default () => {
  const data = useStaticQuery(graphql`
    {
      craft {
        categories(group: "headerFeaturesCategory", siteId: "3") {
          ... on Craft_headerFeaturesCategory_Category {
            slug
            title
          }
        }
        entries(siteId: "3", section: "featurePages", status: "live") {
          typeHandle
          ... on Craft_featurePages_featurePages_Entry {
            slug
            featurePageUrlDirectory {
              slug
            }
            headerFeaturesCategory {
              slug
            }
          }
        }
      }
    }
  `);

  return data.craft;
};
